import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const usePMPStore = defineStore('pmpStore', {
    state:() => ({
        pmp_projects: [],
    }),
    actions : {
        resetPMPStore(){
            this.pmp_projects = []
        },
        getPMPProjectsByBank(bank_code = null) {
            if (!bank_code || bank_code === 'CASH_BUYER') {
                return this.pmp_projects;
            }

            return this.pmp_projects.filter((project) => {
                const codes = project.project_supported_bank_codes || [];
                return Array.isArray(codes) && codes.includes(bank_code);
            });
        },
        getPMPBankCodesByProject(project_id = null){
            let bank_codes = []
            if(!project_id){
                return bank_codes;
            }
            let selected_project = this.pmp_projects.find((project) => project.project_id == project_id)
            if(selected_project){
                bank_codes = selected_project.project_supported_bank_codes
            }
            return bank_codes;
        },
        async getPMPProjects(){
            try{
                const res = await axios.get(services.lookup + 'pmp/projects?ver=1', {headers: getHeader()})
                this.pmp_projects = _gHlp.getValue(res,'data.data.data',_gHlp.getValue(res,'data.data',[]))
            }catch(e){
                this.pmp_projects = []
                console.log('PMP Store (getProjects) failed:' + e.response.data.message)
                throw e
            }
        },
        async getPMPProjectsBasic(){
            try{
                const res = await axios.get(services.lookup + 'pmp/projects?ver=2', {headers: getHeader()})
                this.pmp_projects = _gHlp.getValue(res,'data.data.data',_gHlp.getValue(res,'data.data',[]))
            }catch(e){
                this.pmp_projects = []
                console.log('PMP Store (getProjects) failed:' + e.response.data.message)
                throw e
            }
        },
        async getProjectById(id, source){
            try{
                const res = await axios.get(services.lookup + 'pmp/projects/' + id + '?source=' + source, {headers: getHeader()})
                return res
            }catch(e){
                console.log('PMP Store (getProjectById) failed:' + e.response.data.message)
                throw e
            }
        },
        async getPMPProjectBanks(project_id){
            try{
                const res = await axios.get(services.lookup + 'pmp/project/'+project_id+'/banks', {headers: getHeader()})
                return _gHlp.getValue(res,'data.data.data',_gHlp.getValue(res,'data.data',[]))
            }catch(e){
                console.log('PMP Store (getProjects) failed:' + e.response.data.message)
                throw e
            }
        },
        async syncV2CaseToPMP(case_id){
            try{
                const res = await axios.get(services.lookup + 'pmp/cases.im2uv2/'+case_id+'/sync', {headers: getHeader()})
            }catch(e){
                console.log('PMP Store (syncV2CaseToPMP) failed:' + e.response.data.message)
                throw e
            }
        },
        async checkCanCreatePMPCase(customer_id,unitno_id){
            if(!unitno_id || !customer_id){
                throw 'Missing data'
            }
            let data = {
                unitno_id,
                customer_id
            }
            try{
                const res = await axios.post(services.lookup + 'pmp/cases.im2uv2/check', data, {headers: getHeader()})
            }catch(e){
                console.log('PMP Store (checkCanCreatePMPCase) failed:' + e.response.data.message)
                throw e
            }
        },
        async createCaseApproval(case_id){
            try{
                const res = await axios.post(services.lookup + 'pmp/cases.im2uv2/'+case_id+'/create_approval', null, {headers: getHeader()})
            }catch(e){
                console.log('PMP Store (createCaseApproval) failed:' + e.response.data.message)
                throw e
            }
        }
    }
})